import { features } from '@/mocks/homeData';

export default function Features() {
  return (
    <section id="features" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 text-center">
          为什么选择久播
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feat.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}